module.exports = __webpack_public_path__ + "static/media/vertical03.143c686f.jpg";